function createMatrix(objects, func) {
	const matrix = [];
	const indexMap = [];
	for (let i = 0; i < objects.length; i++) {
		const row = [];
		indexMap.push(objects[i]);
		for (let j = 0; j < objects.length; j++) {
			const result = i === j ? null : func(objects[i], objects[j]);
			row.push(result);
		}
		matrix.push(row);
	}
	return {
		matrix,
		indexMap
	};
}
export { createMatrix };

//# sourceMappingURL=index89.js.map